/*
 Copyright (c), CKSource Holding sp. z o.o. All rights reserved.
 */

import Message, { IMessage } from './../../../message';
import { IDescriptorBody } from '../../../descriptor';

export interface IPacketOptionsMessage extends IMessage {
	flags?: string;
	rooms?: string[];
	except?: string[];
}

export default class PacketOptionsMessage extends Message {
	public static readonly TYPE: number = 11;

	public static readonly DESCRIPTOR_NAME: string = 'PacketOptionsMessage';

	public static readonly DESCRIPTOR: IDescriptorBody = /* #__PURE__ -- @preserve */ ( () => ( {
		fields: {
			flags: {
				type: 'string',
				id: 1
			},
			rooms: {
				type: 'string',
				id: 2,
				rule: 'repeated'
			},
			except: {
				type: 'string',
				id: 3,
				rule: 'repeated'
			}
		}
	} ) )();

	public constructor(
		public readonly flags?: Record<string, unknown>,
		public readonly rooms: string[] = [],
		public readonly except: string[] = []
	) {
		super();
	}

	public toJSON(): IPacketOptionsMessage {
		return {
			flags: this.flags ? JSON.stringify( this.flags ) : undefined,
			rooms: this.rooms?.length ? this.rooms : undefined,
			except: this.except?.length ? this.except : undefined
		};
	}

	public static fromJSON( data: IPacketOptionsMessage ): PacketOptionsMessage {
		return new PacketOptionsMessage(
			data.flags && JSON.parse( data.flags ),
			data.rooms,
			data.except
		);
	}
}
